import { PRODUCT_QUERY_PARAMS } from '@/features/navigation/constants'
import { getBaseURL } from '@/features/navigation/utils/url-helpers'

import { PLPPageProps, PLPPages } from '@/app/(plp)/types'

export const generateSearchUrl = (query?: string) => `/${getBaseURL({ page: PLPPages.Search, query: query })}`

export const getPageNumberFromSearchParams = (searchParams: PLPPageProps['searchParams']) => {
    const pageNumberInSearchParams = searchParams?.[PRODUCT_QUERY_PARAMS.PAGE_NUMBER]

    if (!!pageNumberInSearchParams && typeof pageNumberInSearchParams === 'string') {
        const pageNumber = +pageNumberInSearchParams
        return !isNaN(pageNumber) ? pageNumber : null
    }

    return null
}
